module.exports = __webpack_public_path__ + "assets/img/title-0d1d92cb.png";